import { clone } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Header,
  Label,
  Segment,
} from 'semantic-ui-react';

class Lawyer extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    data: PropTypes.shape({
      lawyerEmail: PropTypes.string,
    }),
    isMobile: PropTypes.bool,
    loading: PropTypes.bool,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  });
  static getPropsToState = (props) => {
    const data = props.data || {};
    return {
      data,
      oriData: clone(data),
    };
  }
  constructor(props) {
    super(props);
    const state = Lawyer.getPropsToState(props);
    this.state = {
      ...state,
      collapseSegments: [{
        hideLawyerInfo: false,
      }],
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = Lawyer.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnCollapseSegment = (e, { name, value }) => {
    const { collapseSegments } = this.state;
    e.preventDefault();
    collapseSegments[name] = !value;
    this.setState({ collapseSegments });
  }
  render() {
    const { isMobile, loading } = this.props;
    const { data } = this.state;
    const { hideLawyerInfo } = this.state.collapseSegments;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
            <Header
              className="new_title"
              as="h5"
              textAlign="center"
              attached="top"
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16} textAlign="center">
                    LAWYER INFO
                  </Grid.Column>
                  <Label
                    as="button"
                    attached="top right"
                    icon={hideLawyerInfo ? 'angle up' : 'angle down' }
                    className="collapse-button"
                    style={{
                      position: 'absolute',
                      right: '0',
                      top: '3px',
                      marginRight: '0',
                      marginTop: '0.5em',
                    }}
                    name="hideLawyerInfo"
                    value={hideLawyerInfo}
                    onClick={this.handleOnCollapseSegment}
                    disabled={loading}
                  />
                </Grid.Row>
              </Grid>
            </Header>
            {
              !hideLawyerInfo ? (
                <Segment attached>
                  <Grid>
                    <Grid.Row verticalAlign="middle">
                      <Grid.Column width={1} textAlign="left">
                        <span style={{ fontWeight: 'bold' }}>Email</span>
                      </Grid.Column>
                      <Grid.Column width={15} textAlign="left">
                        {data ? data.lawyerEmail : ''}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              ) : null
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(Lawyer.mapStateToProps)(Lawyer);



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Lawyer.jsx